import React from "react";
import { Route } from "react-router";
import { Switch } from "react-router-dom";

import DashboardEmpty from "screens/DashboardEmpty";
import DashboardProj from "screens/DashboardProj";
import DashboardStatistics from "../../screens/DashboardStatistics";

const Dashboard = () => {
  return (
    <Switch>
      <Route path="/project/:id" component={DashboardProj} />
      <Route path="/admin" component={DashboardStatistics} />
      <Route path="/" component={DashboardEmpty} />
    </Switch>
  );
};

export default Dashboard;
